<template>
  <div>
    <vs-row class="mb-10">
      <vs-button
        :to="{ name: 'new-news' }"
        class="rounded-full"
        color="primary"
        icon-pack="feather"
        icon="icon-plus-circle"
        type="filled"
        >Создать новость</vs-button
      >
    </vs-row>
    <vs-row class="mb-5">
      <div class="header-filter md:w-1/6 w-full mb-5 mr-5 cursor-pointer">
        <v-select
          @input="getAllNews(currentPagingationPage, countElements)"
          :options="countItemsOmPage"
          :clearable="false"
          placeholder="Количество новостей"
          v-model="countElements"
        >
          <div slot="no-options">Совпадений не найдено</div>
        </v-select>
      </div>
    </vs-row>
    <vs-row class="-mx-4">
      <vs-col
        v-for="(item, index) in news"
        :key="index"
        class="w-full px-4 sm:w-1/2 lg:w-1/3 mb-base"
      >
        <router-link :to="{ path: `/news/${item.id}` }" class="card-wrap">
          <vs-card actionable class="cardx pb-1">
            <div slot="media">
              <img :src="item.image" />
            </div>
            <div>
              <h3 class="mb-3">{{ item.title }}</h3>
              <h6 class="text-primary mb-3">{{ item.date_created }}</h6>
              <div v-html="item.body" class="text-dark"></div>
            </div>
          </vs-card>
        </router-link>
      </vs-col>
    </vs-row>
    <vs-pagination
      class="mt-4"
      :total="totalPagePagination"
      v-model="currentPagingationPage"
    ></vs-pagination>
  </div>
</template>

<script>
import { countItemsOmPage, API_URL } from "@/.env";

export default {
  data: () => ({
    news: [],

    countElements: 20,

    currentPagingationPage: 1,
    totalNews: 0,
    totalPagePagination: 1,
    countItemsOmPage: countItemsOmPage,

    BASE_URL: API_URL,
  }),
  components: {},
  watch: {
    countElements: function () {
      this.currentPagingationPage = 1;
    },
    currentPagingationPage: function () {
      this.changePaginationPage(this.currentPagingationPage);
    },
  },
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatDate(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
    },
    getAllNews(page, limit) {
      this.$vs.loading();

      let payload = {};

      if (page && limit) {
        payload.page = page ? page : 1;
        payload.limit = limit ? limit : 20;
      }

      this.$load(async () => {
        let res = (await this.$api.news.getAllNews(payload ? payload : ""))
          .data;

        this.totalNews = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalNews / this.countElements
        );
        res.results.forEach((news) => {
          news.date_created = this.formatDate(news.date_created);
          if (news.image !== null) {
            news.image = this.BASE_URL + news.image;
          }
        });

        this.news = res.results;
        this.$vs.loading.close();
      });
    },
    changePaginationPage(page) {
      this.getAllNews(page, this.countElements);
    },
  },
  created() {},
  mounted() {
    this.getAllNews();
  },
};
</script>